import { reactive } from '@/core/reactive/reactive';
import { BestBuyClient } from '@/core/reactive/services/sdk';
import { LoginConfig } from '@/core/config';

export const BestBuyService = reactive.service(
  'bestbuy',
  BestBuyClient,
)(Service => new Service(LoginConfig.current?.api?.host ?? ''));

export const BestBuyReactor = BestBuyService.reactor('bestbuyServiceReactor', {
  success: () => {},
});
